// Template Variables Helper
// Provides consistent company fields across all template types

export const getCompanyVariables = (companySettings) => {
  if (!companySettings) {
    return {
      company_name: 'Your Company Name',
      company_address: 'Your Company Address',
      company_address_line1: '',
      company_address_line2: '',
      company_city: '',
      company_county: '',
      company_postcode: '',
      company_phone: '',
      company_mobile: '',
      company_email: '',
      company_accounts_email: '',
      company_website: '',
      company_vat_number: '',
      company_number: '',
      company_logo: ''
    };
  }

  // Build full address
  const companyAddressParts = [
    companySettings.address_line1,
    companySettings.address_line2,
    companySettings.city,
    companySettings.county,
    companySettings.postcode
  ].filter(Boolean);
  const companyAddress = companyAddressParts.join(', ');

  return {
    company_name: companySettings.company_name || 'Your Company Name',
    company_address: companyAddress || 'Your Company Address',
    company_address_line1: companySettings.address_line1 || '',
    company_address_line2: companySettings.address_line2 || '',
    company_city: companySettings.city || '',
    company_county: companySettings.county || '',
    company_postcode: companySettings.postcode || '',
    company_phone: companySettings.phone || '',
    company_mobile: companySettings.mobile || '',
    company_email: companySettings.email || '',
    company_accounts_email: companySettings.accounts_email || '',
    company_website: companySettings.website || '',
    company_vat_number: companySettings.vat_number || '',
    company_number: companySettings.company_number || '',
    company_logo: companySettings.logo_url || '',
    // Formatted versions
    company_phone_formatted: companySettings.phone ? `Tel: ${companySettings.phone}` : '',
    company_mobile_formatted: companySettings.mobile ? `Mobile: ${companySettings.mobile}` : '',
    company_email_formatted: companySettings.email ? `Email: ${companySettings.email}` : '',
    // Our Bank Details
    bank_name: companySettings.bank_name || '',
    bank_account_name: companySettings.bank_account_name || '',
    bank_sort_code: companySettings.bank_sort_code || '',
    bank_account_number: companySettings.bank_account_number || '',
    bank_iban: companySettings.bank_iban || '',
    bank_swift: companySettings.bank_swift || '',
    bank_details: companySettings.bank_details || '',
    bank_remittance_email: companySettings.bank_remittance_email || '',
    // eCap Bank Details
    ecap_bank_name: companySettings.ecap_bank_name || '',
    ecap_account_name: companySettings.ecap_account_name || '',
    ecap_sort_code: companySettings.ecap_sort_code || '',
    ecap_account_number: companySettings.ecap_account_number || '',
    ecap_iban: companySettings.ecap_iban || '',
    ecap_swift: companySettings.ecap_swift || '',
    ecap_bank_details: companySettings.ecap_bank_details || '',
    ecap_remittance_email: companySettings.ecap_remittance_email || '',
    ecap_legal_text: companySettings.ecap_legal_text || '',
    // Legal Wording
    company_legal_wording: companySettings.legal_wording || ''
  };
};
